export default [
  {
    iconName: 'verified',
    headLine: 'flexible bookings',
    subHeadLine:
      'Plans change. That’s why we offer free cancellation on most hotels & rental cars.'
  },
  {
    iconName: 'discount',
    headLine: 'incredible deals',
    subHeadLine: 'Check out with confidence. Priceline members always get our best price.',
    href: '/static-pages/best-price-guarantee.html'
  },
  {
    iconName: 'cars',
    headLine: 'no flight? no problem',
    subHeadLine: 'Bundle hotel & rental car deals to build your perfect getaway. No airtime required.'
  },

  {
    iconName: 'help',
    headLine: 'help 24/7',
    subHeadLine:
      'We’re always here for you – reach us 24 hours a day, 7 days a week.',
    href: '/coronavirus'
  }
]
